import { CompositeLayer } from '../composite/composite-layer';
import { GeoJsonLayer } from '../geojson/geojson-layer';
import { RasterTileLayer } from '../tile/tile-layer';

export class SigWxLayer extends CompositeLayer {
    private geoJson: GeoJsonLayer | null = null;
    private tileLayer: RasterTileLayer | null = null;

    protected onAdd(): void {
        this.geoJson = new GeoJsonLayer(
            this.map,
            this.workspaceId,
            this.dispatcher,
            this.productId,
            this.slotTopLayerId,
            this.settings,
            'geojson'
        );
        this.tileLayer = new RasterTileLayer(
            this.map,
            this.workspaceId,
            this.dispatcher,
            this.productId,
            this.slotTopLayerId,
            this.settings,
            'tiles'
        );
        this.addLayer(this.geoJson);
        this.addLayer(this.tileLayer);
    }
}
